import React from 'react'
import { useQuery } from 'react-query'
import { httpClient } from '../../utils'
import {Spinner} from '../../layouts'
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const fetchOrders = async () => {
    const { data } = await httpClient.get('orders');
    return data;
}

function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
  
    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">Order #{row.orderId}</TableCell>
          <TableCell align="left">{row.clientId}</TableCell>
          <TableCell align="left">{row.paymentMethod.toUpperCase()}</TableCell>
          <TableCell align="left">{row.total} DH</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Details
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell>Meal Name</TableCell>
                      <TableCell>Quantity</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[{
                        mealName: 'Checken tonder',
                        quantity: 2,
                    },{
                        mealName: 'Pizza polonaize',
                        quantity: 3,
                    }].map((orderItem, index) => (
                      <TableRow key={index}>
                        <TableCell />
                        <TableCell component="th" scope="row">
                          {orderItem.mealName}
                        </TableCell>
                        <TableCell>{orderItem.quantity}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
}

const OrderList = () => {

    const {data:orders, status} = useQuery('orders', fetchOrders);

    if (status === 'loading') return (
        <Spinner />
    )

    if (status === 'success') return (
        <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                <TableRow>
                    <TableCell />
                    <TableCell>Order Number</TableCell>
                    <TableCell align="left">Table</TableCell>
                    <TableCell align="left">Payment Method</TableCell>
                    <TableCell align="left">Total Price</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {orders.map((row, index) => (
                    <Row key={index} row={row} />
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default OrderList